import { Page, Text, View, Document, StyleSheet, PDFDownloadLink, Image } from "@react-pdf/renderer";
import Graphs from "./Tables/Graphs";

const styles = StyleSheet.create({
  page: {
    position: "relative",
    flexDirection: "row",
    flexWrap: "wrap",  // ✅ allows two columns to wrap
    alignItems: "flex-start",
    paddingTop: 10,
    paddingRight: 20,
    paddingLeft: 20,
    paddingBottom: 10,
    width: "100%",
    height: "100%"
  },
 headerContainer: {
    marginBottom: 2
  },
  titleRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 3
  },
  title: {
    fontSize: 18,
    fontWeight: "bold",
    color: "#002060"
  },
  gridRow: {
    flexDirection: "row",
    flexWrap: "wrap"
  },
  col: {
    width: "25%",
    paddingRight: 8,
    marginBottom: 8
  },
  colRight: {
    width: "25%",
    paddingRight: 8,
    marginBottom: 8,
    alignItems: "flex-end"
  },
  largePrice: {
    fontSize: 12,
    fontWeight: "bold"
  },
  green: {
    color: "green",
    fontSize: 8,
  },
  red: {
    color: "red",
    fontSize: 10,
  },
  text: {
    fontSize: 8,
  },
  logo: {
    position: "absolute",
    right: 20,    // distance from right edge
    width: 50,
    height: 30,
  },
  description: {
    width: "100%",
    fontSize: 8,
    marginBottom: 8,
    paddingHorizontal: 3,
    lineHeight: 1.25,
  },  
  chartWrapper: {
    width: "50%",      // ✅ two per row (with a little spacing)
    marginBottom: -5, 
  },
  chart: {
    width: "100%",
  },
  footer: {
    width: "100%",
    fontSize: 8,
    paddingHorizontal: 3,
    lineHeight: 1.2,
  },
  footerLogo: {
    position: "absolute",
    right: -30,    // distance from right edge
    width: 35,
    height: 10,
  },
});

const HeaderPDF = ({ data }) => {
  const {
    companyName,
    ticker,
    latestPrice,
    priceChange,
    percentChange,
    latestDate,
    marketCap,
    sectorName,
    stockCurrency,
    primaryExchange,
    companyWebsite,
    companyLocation
  } = data;

  return (
    <View style={styles.headerContainer}>

      {/* TITLE ROW */}
      <View style={styles.titleRow}>
        <Text style={styles.title}>
          {companyName} ({ticker})
        </Text>
        <Image style={styles.logo} src="/fsa_logo.png" />
      </View>

      {/* CONTENT ROW */}
      <View style={styles.gridRow}>

        {/* Column 1 */}
        <View style={styles.col}>
          <Text style={styles.largePrice}>
            ${latestPrice} 
            <Text style={percentChange >= 0 ? styles.green : styles.red}>
              {" "}
              {percentChange >= 0 ? `+${priceChange}` : priceChange} (
              {percentChange >= 0 ? `+${percentChange}%` : `${percentChange}%`}
              )
            </Text>
            <Text style={styles.text}> as of {latestDate}</Text>
          </Text>

          <Text style={styles.text}>Market Cap: {marketCap}</Text>
          <Text style={styles.text}>{sectorName}</Text>
        </View>

        {/* Column 2 */}
        <View style={styles.col}>
          <Text style={styles.text}>Financials Reported In: {stockCurrency}</Text>
          <Text style={styles.text}>Stock Chart In: {stockCurrency}</Text>
          <Text style={styles.text}>Primary Exchange: {primaryExchange}</Text>
        </View>

        {/* Column 3 */}
        <View style={styles.col}>
          <Text style={styles.text}>{companyWebsite}</Text>
          <Text style={styles.text}>{companyLocation}</Text>
        </View>

        {/* Column 4 */}
        <View style={styles.colRight}>
          <Text style={styles.text}>www.fsavaluation.com</Text>
          <Text style={styles.text}>416 453-5875</Text>
        </View>

      </View>
    </View>
  );
};

export const Pdf = ({ chartImage, description, headerData }) => (
  <Document>
    <Page size="A4" style={styles.page}>
      {/* ✅ Description text at the top */}
      
      <HeaderPDF data={headerData} />

      <View style={{ width: "100%" }}>
        <Text style={styles.description}>{description}</Text>
      </View>

      {/* ✅ Charts below */}
      {chartImage.map((img, i) => (
        <View key={i} style={styles.chartWrapper}>
          <Image src={img} style={styles.chart} />
        </View>
      ))}

      <View>
        <Text style={styles.footer}>
          <Image style={styles.footerLogo} src="/morningstar.png" />
        Morningstar provides financial statement and stock market pricing data to FSA Valuation Service Inc. for QuickFINANCIAL and related products.
        © {new Date().getFullYear()} FSA Valuation Service Inc. and Morningstar, Inc.   All Rights Reserved.  The QuickFINANCIAL model and the data contained herein: (1) is the proprietary to FSA Valuation Service Inc., Morningstar and/or its content providers; (2) is not warranted to be accurate, complete or timely.  FSA, Morningstar or its content providers are not responsible for any damages or losses arising from any use of this information.  Past performance is no guarantee of future results.
        </Text>
      </View>

    </Page>
  </Document>
);

export function DownloadInvoiceButton({ chartImage, description, headerData }) {

  const allImagesReady = chartImage && chartImage.length > 0 && chartImage.every(img => img);
  const ticker = headerData.ticker

  return (
<button
  disabled={!allImagesReady}
  style={{
    padding: "8px 16px",
    marginLeft: 10,
    background: allImagesReady ? "#464f62" : "#999",
    color: "#fff",
    border: "none",
    borderRadius: 4,
    cursor: allImagesReady ? "pointer" : "not-allowed",
  }}
>
  {allImagesReady ? (
    <PDFDownloadLink
      document={<Pdf chartImage={chartImage} description={description} headerData={headerData} />}
      fileName={`${ticker}.pdf`}
      style={{ color: "#fff", textDecoration: "none" }}
    >
      Download PDF
    </PDFDownloadLink>
  ) : (
    "Preparing..."
  )}
</button>

  );
}